import { render, staticRenderFns } from "./qs2-16.vue?vue&type=template&id=6bc5175c&scoped=true&"
import script from "./qs2-16.vue?vue&type=script&lang=js&"
export * from "./qs2-16.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc5175c",
  null
  
)

export default component.exports